import { TrackingDataProps } from '../../../../../../common/AnalyticsContext/LinkTracking';
import { applyTrackingId } from '../../../../../../common/AnalyticsContext/applyTrackingId';
import { Container, LogoContainer, Name, PromotionIcon } from './SpecialtyPill.styles';

interface Props {
  className?: string;
  name: string;
  logoPath?: string;
  url?: string;
  setValue: Setter<string>;

  topNavName?: string; //optional top-nav only name that 'replaces' the 'name' string for DISPLAY ONLY. not for search bar input.
}

export const SpecialtyPill = ({
  className,
  name,
  logoPath,
  url,
  setValue,
  trackingId,
  topNavName,
}: Props & TrackingDataProps) => (
  <>
    {url ? (
      <Container className={className} as="a" href={url} {...applyTrackingId(trackingId)}>
        <LogoContainer>{logoPath && <PromotionIcon path={logoPath} />}</LogoContainer>
        <Name>{topNavName ?? name}</Name>
      </Container>
    ) : (
      <Container
        className={className}
        onClick={() => setValue(`${name} in `)}
        {...applyTrackingId(trackingId)}
      >
        <LogoContainer>{logoPath && <PromotionIcon path={logoPath} />}</LogoContainer>
        <Name>{topNavName ?? name}</Name>
      </Container>
    )}
  </>
);
